// import React, { useState, useEffect } from 'react';
// import { connect, useSelector } from 'react-redux';
import CommonLoader from '../../shared/Loaders/CommonLoader/CommonLoader';
import { paymentInfoStyle as styles } from './paymentInfo.tailwind';
// import PaymentButtons from './paymentButtons.data';
import StripeElement from './StripeElement/StripeElement';
// import Button from '../../shared/Button/Button';
// import stripeLogo from '../../../assets/images/stripe.png'
// import { createPaymentButtonIntent } from '../../../redux/slices/paymentSlice';
// import { PAYMENT_METHOD_TYPE } from '../../../lib/constants/globalConstant';
// import OverlayLoader from '../../shared/Loaders/OverlayLoader/OverlayLoader';
// import CommonLoader from '../../shared/Loaders/CommonLoader/CommonLoader';

const PaymentMethods = ({ orderId, seasonId, handleOpenModal, paymentButtonIntent, setPaymentIntentLoaded }) => {
  // const { cartData } = useSelector(state => state.cart);
  // const { paymentButonResponse } = useSelector(state => state.payment);
  // const paymentMethodType = paymentButonResponse?.paymentMethodType;

  // const [loader, setLoader] = useState(false);
  // TODO: Add all payment buttons for loading for stripe using (loader)

  // Stripe Button
  // const handleStripeButton = async() => {
  //   const data = {
  //     orderId,
  //     seasonId,
  //     paymentMethodType: PAYMENT_METHOD_TYPE.STRIPE
  //   }

  //   setLoader(true); // show-loader

  //   await paymentButtonIntent(data);
  //   // if(createPaymentButtonIntent.fulfilled.match(paymentResponse)) {
      
  //   // }

  //   setLoader(false) // hide-loader
  // }

  // to select the payment method automatically as stripe 
  // useEffect(() => {
  //   // Automatically set the payment method to STRIPE when the component mounts
  //   // setPaymentIntentLoaded({ paypal: true }); // Mark as loaded if needed
  //   // handleStripeButton(); // Directly trigger the Stripe button logic
  // }, [setPaymentIntentLoaded]);

  // if (loader) {
  //   return <CommonLoader />;
  // }
  
  return (
    <div className={styles.outerBox}>

      {/* <div className={styles.borderBottom}>
        <h2 className={styles.heading}>Choose Payment Method</h2>
      </div>

      {/* Payment Methods Section */}
      {/*
      <div className={`${styles.payment_methods} ${paymentMethodType === PAYMENT_METHOD_TYPE.STRIPE ? `border-b border-cartBorder` : ''}`}>
        {/* Other Payment Buttons */}
        {/*
        {PaymentButtons?.map(({ PaymentButton }, key) => (
          // Button [Paypal, Venmo, etc.]
          <PaymentButton
            key={key}
            orderId={orderId}
            seasonId={seasonId}
            handleOpenModal={handleOpenModal}
            setPaymentIntentLoaded={setPaymentIntentLoaded}
          />
        ))}

        {/* Stripe Button */}
        {/*
        {(!paymentMethodType || paymentMethodType !== PAYMENT_METHOD_TYPE.STRIPE) && (
          <div className={styles.other_payment_buttons}>
            {/* Stripe Button for Credit/ Debit Card */}
            {/*
            <Button variant='pay' style={{ width: '100%', maxWidth: 'unset' }} className={styles.buttonContainer} onClick={handleStripeButton}>
              <img src={stripeLogo} alt="" className={styles.button} />
            </Button>
          </div>
        )}
      </div> */}


      {/* Stripe Element(CARD) */}
      <StripeElement orderId={orderId} seasonId={seasonId} />
      {/* {paymentMethodType === PAYMENT_METHOD_TYPE.STRIPE && <StripeElement orderId={orderId} />} */}
    </div>
  )
};

// const mapDispatchToProps = (dispatch) => ({
//   paymentButtonIntent: (data) => dispatch(createPaymentButtonIntent(data)),
// });

// export default connect(null, mapDispatchToProps)(PaymentMethods);
export default PaymentMethods;